import React from 'react';
import { XIcon } from '@heroicons/react/solid'
import { cls } from './utils';

const Alert = ({warning, visible = true,  error, success, info, afterHr, accent, header, content, list, className, icon : Icon, testId = null, children, onDismiss}) => {
    
    if (!visible)
        return null
    const bg = warning && 'bg-yellow-50'
                || error && 'bg-red-50'
                || success && 'bg-green-50'
                || afterHr && 'bg-red-100'
                || info && 'bg-is-blue-20'
                || 'bg-gray-100'
    const border = warning && 'border-yellow-400'
                    || error && 'border-red-400'
                    || success && 'border-green-400'
                    || afterHr && 'border-transparent'
                    || info && 'border-transparent'
                    || 'border-gray-600'
    const color = /*warning && 'text-yellow-800'
                    || error && 'text-red-800'
                    || success && 'text-green-800'
                    || afterHr && 'text-red-800'
                    || info && 'text-inherit'
                    || 'text-gray-800'
                    || */ 'text-black'
    const iconColor = warning && 'text-yellow-400'
                    || error && 'text-red-400'
                    || success && 'text-green-400'
                    || afterHr && 'text-red-100 fill-red-400'
                    || info && 'text-blue-50 fill-blue-400'
                    || 'text-gray-400'
    const borderRad = afterHr && 'rounded-md'

    return ( 
        <div className={cls(bg,"p-4 rounded",accent&&`border-l-4 ${border}`,color, borderRad, className, afterHr && "flex items-center mb-6", !afterHr && "shadow md:shadow-none mb-4")} data-testid={testId}>
            <div className={cls("flex msg", afterHr && "flex items-center")}>
                {Icon && <div className="mr-3">
                   <Icon className={cls("h-5 w-5",iconColor)} aria-hidden="true" />
                </div>
                }
                <div>
                    <h5>{header}</h5>
                </div>
                {onDismiss && <div className="ml-auto pl-3">
                    <div className="-mx-1.5 -my-1.5">
                        <button
                        type="button"
                        onClick={()=>onDismiss()}
                        className={cls("inline-flex rounded-md p-1.5  focus:outline-none focus:ring-2 focus:ring-offset-2",color)}
                        >
                            <span className="sr-only">Dismiss</span>
                            <XIcon className="h-5 w-5" aria-hidden="true" />
                        </button>
                    </div>
                </div>}
            </div>
            {(list||content||children) && <div className={cls(!afterHr && !info && "mt-2")}>
                {list && <ul role="list" className={cls(" list-disc pl-5 space-y-1")}>
                                {list.map((l,i)=><li key={i}>{l}</li>)}
                            </ul>}
                {content && <p className=''>{content}</p>}
                {children}
            </div>}
            
            
        </div>
     );
}
 
export default Alert;